import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import images from '../Theming/images';
import '../Theming/Fonts/custom-fonts.css';

const NavBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #0033a1;
  padding: 10px 15px;
  height: 60px;
  position: fixed;
  font-family: TIMSans-Regular;
  z-index: 2;
  width: 100%;
`;

const BackIcon = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  img {
    height: 24px;
    width: 24px;
  }
`;

const Title = styled.div`
  flex: 1;
  text-align: center;
  font-size: 18px;
  color: white;
`;

const TimTopNavigation = () => {
  if (i18n.language != 'it') {
    i18n.changeLanguage('it');
  }
  const { t } = useTranslation();

  const handleBackClick = () => {
    if (window.history.length > 1) {
      window.history.back();
    }
  };

  return (
    <NavBar>
      <BackIcon onClick={handleBackClick}>
        <img
          width={24}
          height={24}
          src={images.tim_left_icon?.default}
          alt="Back"
        />
      </BackIcon>
      <Title>{t('PartnerNewpluginsdkActivate.timTopNavigationTitle')}</Title>
    </NavBar>
  );
};

export default TimTopNavigation;
